export default {
	user: null,
	token: null,
	company: null,
	products: [],
	isMobile: false,
};



// WEBPACK FOOTER //
// ./src/store/state.js